import React, { Component } from 'react';
import shallowCompare from 'react-addons-shallow-compare';
import moment from 'moment';

import { MagazineArticleShape } from 'entities';
import Article from 'components/ArticleOuter/Article';
import quantity from 'quantity';
import bbCodeRemover from 'bbCodeRemover';

class MagazineArticle extends Component {

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  render() {
    const { magazineArticle, ...otherProps } = this.props;
    const { summary } = magazineArticle;
    const excerpt = summary ? bbCodeRemover(summary) : '';

    return (
      <Article
        excerpt={excerpt}
        title={magazineArticle.title}
        date={magazineArticle.createdAt}
        authorName={magazineArticle.author.userName}
        authorAvatarUrl={magazineArticle.author.avatar.url}
        commentsInfo={`${magazineArticle.commentCount} ${quantity(magazineArticle.commentCount, __('entities.comments.singular'), __('entities.comments.plural'))}`}
        categories={magazineArticle.topics.map(({ id, title }) => ({url: `/magazine?topic=${id}`, name: title}))}
        createdAt={moment(magazineArticle.createdAt).format(process.env.KOOTH_DATE_FORMAT)}
        articleUrl={`magazine/articles/${magazineArticle.id}`}
        {...otherProps}
        />
    );
  }
}

MagazineArticle.propTypes = {
  magazineArticle: MagazineArticleShape
};

export default MagazineArticle;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/containers/MagazineArticle/index.js
 **/